import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

// Actions
export const FETCH_EXTERNAL_BILL_OF_LADINGS = "fetchExternalBillOfLadings";
export const FETCH_EXTERNAL_BILL_OF_LADING = "fetchExternalBillOfLading";
export const DELETE_EXTERNAL_BILL_OF_LADING = "deleteExternalBillOfLading";
export const APPROVE_EXTERNAL_BILL_OF_LADING = "approveExternalBillOfLading";

// Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingBillOfLading";
export const SET_BILL_OF_LADING = "setBillOfLading";
export const SET_LOADING_EXTERNAL = "setLoadingExternalBillOfLading";
export const SET_EXTERNAL_BILL_OF_LADING = "setExternalBillOfLading";

const state = {
  errors: [],
  external_bill_of_lading: [],
  isLoadingBillOfLading: false,
  isLoadingExternalBillOfLading: false
};

const getters = {
  isLoadingExternalBillOfLading() {
    return state.isLoadingExternalBillOfLading;
  },
  getExternalBillOfLading() {
    return state.external_bill_of_lading;
  }
};

const actions = {
  [FETCH_EXTERNAL_BILL_OF_LADINGS](context, apiParams = "") {
    context.commit(SET_LOADING_EXTERNAL, true);

    return new Promise((resolve, reject) => {
      ApiService.get("external-bill-of-lading" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING_EXTERNAL, false);
        });
    });
  },

  [FETCH_EXTERNAL_BILL_OF_LADING](context, id) {
    context.commit(SET_LOADING_EXTERNAL, true);

    return new Promise((resolve, reject) => {
      ApiService.get("external-bill-of-lading", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING_EXTERNAL, false);
        });
    });
  },

  [DELETE_EXTERNAL_BILL_OF_LADING](context, id) {
    context.commit(SET_LOADING_EXTERNAL, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("external-bill-of-lading", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING_EXTERNAL, false);
        });
    });
  },
  [APPROVE_EXTERNAL_BILL_OF_LADING](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`external-bill-of-lading/${id}/approve`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING_EXTERNAL, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingBillOfLading = false;
    state.isLoadingExternalBillOfLading = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingBillOfLading = value;
  },
  [SET_LOADING_EXTERNAL](state, value) {
    state.isLoadingExternalBillOfLading = value;
  },
  [SET_EXTERNAL_BILL_OF_LADING](state, data) {
    state.isLoadingExternalBillOfLading = false;
    state.external_bill_of_lading = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
